import {
  RequestOTPRequest,
  RequestOTPResponse,
  VerifyBankIDStepUpRequest,
  VerifyOTPRequest,
  VerifyOTPResponse,
} from '@/types/api/auth';
import { RequestBankIDStepUpResponse } from '@/types/api/auth/response/request-bankid-step-up.response';
import { VerifyBankIDStepUpResponse } from '@/types/api/auth/response/verify-bankid-step-up.response';
import { authenticatedClient, unauthenticatedClient } from '@/utils/shared/axios';
import { handleApiError } from '@/utils/shared/handle-api-error';

export default {
  requestOTPLogin: async (data: RequestOTPRequest) => {
    try {
      const response = await unauthenticatedClient.post<RequestOTPResponse>('/auth/login/otp/request', data);

      return response.data;
    } catch (error: any) {
      throw handleApiError(error);
    }
  },

  verifyOTPLogin: async (data: VerifyOTPRequest) => {
    try {
      const response = await unauthenticatedClient.post<VerifyOTPResponse>('/auth/login/otp/verify', data);

      return response.data;
    } catch (error: any) {
      throw handleApiError(error);
    }
  },

  bankid: {
    request: async () => {
      try {
        const response = await authenticatedClient.post<RequestBankIDStepUpResponse>('/auth/step-up/bankid/request');

        return response.data;
      } catch (error: any) {
        throw handleApiError(error);
      }
    },

    verify: async (data: VerifyBankIDStepUpRequest) => {
      try {
        const response = await authenticatedClient.post<VerifyBankIDStepUpResponse>(
          '/auth/step-up/bankid/verify',
          data,
        );

        return response.data;
      } catch (error: any) {
        throw handleApiError(error);
      }
    },
  },

  session: {
    revoke: async () => {
      try {
        const response = await authenticatedClient.post<void>('/auth/sessions/revoke', {});

        return response.data;
      } catch (error: any) {
        throw handleApiError(error);
      }
    },

    refresh: async () => {
      try {
        const response = await unauthenticatedClient.post<{ token: string }>('/auth/sessions/refresh', {});

        return response.data;
      } catch (error: any) {
        throw handleApiError(error);
      }
    },

    switchContext: async (groupId: string) => {
      try {
        const response = await authenticatedClient.put<{ token: string }>('/auth/sessions/context', { groupId });

        return response.data;
      } catch (error: any) {
        throw handleApiError(error);
      }
    },
  },
};
